import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import PublicModalWrappers from '../public/PublicModalWrappers';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { sendEmailInvitation } from '../../store/actions/campaign-summary-actions';
import { checkEmailAddress } from '../../utilities/helpers';

const ShareCampaign = props => {
  const dispatch = useDispatch();
  const [modalIsOpen, closeModal] = useState(false);

  const [emailList, changeEmailList] = useState(['']);
  const [isEmailWrongFormat, setEmailWrongFormat] = useState(false);

  const currentSharingCampaignId = useSelector(
    state => state.campaign.currentSharingCampaignId
  );

  const handleEmailChange = (e, idx) => {
    const newEmailList = emailList.concat();

    newEmailList[idx] = e.target.value;

    checkEmailAddress(e.target.value) === false ?  setEmailWrongFormat(true) : setEmailWrongFormat(false);

    changeEmailList(newEmailList);

  }

  const sendInvitation = () => {
    dispatch(
      sendEmailInvitation(
        {
          type: 'audienceSummary',
          usernames: emailList.map(item => item).join(),
        },
        currentSharingCampaignId
      )
    );
  };

  const addEmailAddress = () =>{
    if(emailList.length > 4){
      return;
    }

    const newEmailList = emailList.concat();

    newEmailList.push("");

    changeEmailList(newEmailList);
  }

  return (
    <div>
      <div className="ShareCampaign_container">
        <div className="ShareCampaign_first-invitation">
          <div className="ShareCampaign_first-invitation-title">
            Share This Campaign
          </div>
          <div className="ShareCampaign_first-invitation-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id et netus
            dui, vestibulum sed auctor diam aliquet sed.
          </div>
          <div className="ShareCampaign_first-invitation-button-area">
            <div
              className="CampaignSummary_container_create-campaign-btn"
              style={{ width: '137.27px' }}
              onClick={() => closeModal(true)}
            >
              <AddIcon />
              <div className="CampaignSummary_container_create-campaign-btn-text">
                Send Invite
              </div>
            </div>
          </div>
        </div>

        <PublicModalWrappers
          isOpen={modalIsOpen}
          close={() => closeModal(!modalIsOpen)}
          width="40%"
        >
          <div className="ShareCampaign_send-invite-area">
            <div className="ShareCampaign_mail-icon">
              <MailOutlineIcon style={{ fill: '#FF856D' }} />
            </div>

            <div
              className="ShareCampaign_first-invitation-title"
              style={{ margin: 5 }}
            >
              Send invite
            </div>
            <div
              className="ShareCampaign_first-invitation-description"
              style={{ margin: 5, padding: ' 0 5rem 0 5rem' }}
            >
              Add email addresses to share the Campaign Audience Summary
            </div>
            {emailList.map((item, idx) => {
                console.log(item);
              return (
              <input
                className="ShareCampaign_email-input"
                placeholder="Enter email address"
                onChange={e => handleEmailChange(e, idx)}
                value={emailList[idx]}
              />
            )}
            )}

            {isEmailWrongFormat && (
              <span className="CampaignSummaryAuth_error-message">
                Email format incorrect
              </span>
            )}

            <div className="ShareCampaign_add-email" onClick={()=> addEmailAddress()}>
              + Add another mail address
            </div>
            <div className="ShareCampaign_send-invite-button-area">
              <div className="ShareCampaign_cancel-button">Cancel</div>
              <div
                className="ShareCampaign_confirm-button"
                onClick={() => sendInvitation()}
              >
                Send invitation
              </div>
            </div>
          </div>
        </PublicModalWrappers>
      </div>
    </div>
  );
};

export default ShareCampaign;
